import React from "react";
import { useTranslation } from "react-i18next";

const CustomErrorMsgArray = ({ name, errors, touched }) => {
  const { t, i18n } = useTranslation();

  const getError = (name) => {
    const errorPath = name.split(/[[\].]+/).filter(Boolean); // Split on dots or brackets
    let errorObj = errors;
    let touchedObj = touched;

    for (let key of errorPath) {
      if (!errorObj || !touchedObj) break;
      errorObj = errorObj[key];
      touchedObj = touchedObj[key];
    }

    if (errorObj && touchedObj) {
      return errorObj; // Return error message if error and touched are present
    }
    return null;
  };

  const errorMessage = getError(name);

  return (
    <div className="error-message" style={{ fontSize: "14px" }}>
      {errorMessage && <span className="text-danger">{t(errorMessage)}</span>}
    </div>
  );
};

export default CustomErrorMsgArray;
